"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _useDidUpdateEffect = _interopRequireDefault(require("../../hooks/useDidUpdateEffect"));
var _AttachMoney = _interopRequireDefault(require("@material-ui/icons/AttachMoney"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    item: {
      height: theme.spacing(4)
    }
  };
});
var FeatureItem = function FeatureItem(_ref) {
  var feature = _ref.feature,
    isAll = _ref.isAll,
    features = _ref.features,
    setFeatures = _ref.setFeatures,
    isAllChecked = _ref.isAllChecked,
    setIsAllChecked = _ref.setIsAllChecked;
  var _useStyles = useStyles(),
    item = _useStyles.item;
  var _useState = (0, _react.useState)(features.map(function (f) {
      return f.id;
    }).includes(feature.id)),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  var isChecked = (0, _react.useMemo)(function () {
    return features.map(function (f) {
      return f.id;
    }).includes(feature.id);
  }, [features]);
  (0, _react.useEffect)(function () {
    setChecked(isChecked);
  }, [features]);
  var handleCheck = function handleCheck(e) {
    if (isAll) {
      setIsAllChecked(!isAllChecked);
      return;
    }
    setIsAllChecked(false);
    // time out acts as next tick here
    setTimeout(function () {
      var ffs = isChecked ? _toConsumableArray(features).filter(function (cg) {
        return cg.id !== feature.id;
      }) : [].concat(_toConsumableArray(features), [feature]);
      setFeatures(ffs);
    }, 0);
  };
  return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    dense: true,
    className: item,
    onClick: handleCheck,
    disableGutters: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
    color: "primary",
    edge: "start",
    checked: isAll ? isAllChecked : checked,
    disableRipple: true
  })), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    color: "textPrimary",
    variant: "body2"
  }, feature.name)));
};
var FeatureGroup = function FeatureGroup(_ref2) {
  var group = _ref2.group,
    features = _ref2.features,
    setFeatures = _ref2.setFeatures;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isAllChecked = _useState4[0],
    setIsAllChecked = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    collaped = _useState6[0],
    setCollaped = _useState6[1];
  (0, _useDidUpdateEffect["default"])(function () {
    setFeatures(isAllChecked ? [].concat(_toConsumableArray(features), _toConsumableArray(group.features)) : _toConsumableArray(features.filter(function (f) {
      return group.features.map(function (gf) {
        return gf.id;
      }).includes(f.id) === false;
    })));
  }, [isAllChecked]);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.List, {
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    onClick: function onClick() {
      return setCollaped(!collaped);
    },
    disableGutters: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    color: "textPrimary",
    variant: "subtitle1",
    gutterBottom: true
  }, group.name)), collaped ? /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
    "in": !collaped
  }, group.features.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(FeatureItem, {
    feature: {
      name: "Select All"
    },
    group: group,
    isAll: true,
    features: features,
    setFeatures: setFeatures,
    isAllChecked: isAllChecked,
    setIsAllChecked: setIsAllChecked
  }), (group.features || []).map(function (feature, index) {
    return /*#__PURE__*/_react["default"].createElement(FeatureItem, {
      key: index,
      group: group,
      feature: feature,
      features: features,
      setFeatures: setFeatures,
      isAllChecked: isAllChecked,
      setIsAllChecked: setIsAllChecked
    });
  })))), /*#__PURE__*/_react["default"].createElement(_core.Divider, null));
};
var PriceGroup = function PriceGroup(_ref3) {
  var minPrice = _ref3.minPrice,
    maxPrice = _ref3.maxPrice,
    setMinPrice = _ref3.setMinPrice,
    setMaxPrice = _ref3.setMaxPrice;
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    collaped = _useState8[0],
    setCollaped = _useState8[1];
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.List, {
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    onClick: function onClick() {
      return setCollaped(!collaped);
    },
    disableGutters: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    color: "textPrimary",
    variant: "subtitle1",
    gutterBottom: true
  }, "Price Range")), collaped ? /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
    "in": !collaped
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    value: maxPrice,
    variant: "outlined",
    size: "small",
    type: "number",
    label: "max",
    InputProps: {
      startAdornment: /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react["default"].createElement(_AttachMoney["default"], {
        fontSize: "small"
      }))
    },
    onChange: function onChange(e) {
      return setMaxPrice(e.target.value);
    }
  }))))));
};
function Filter(_ref4) {
  var groups = _ref4.groups,
    features = _ref4.features,
    setFeatures = _ref4.setFeatures,
    showPrice = _ref4.showPrice,
    minPrice = _ref4.minPrice,
    maxPrice = _ref4.maxPrice,
    setMinPrice = _ref4.setMinPrice,
    setMaxPrice = _ref4.setMaxPrice;
  var clear = function clear() {
    setFeatures([]);
  };
  return /*#__PURE__*/_react["default"].createElement(_core.List, {
    disablePadding: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    spacing: 2,
    container: true,
    alignItems: "center",
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "h6"
  }, "Filter boats")), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    size: "small",
    color: "primary",
    fullWidth: true,
    variant: "outlined",
    onClick: clear
  }, "Show all")), showPrice && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(PriceGroup, {
    minPrice: minPrice,
    setMinPrice: setMinPrice,
    maxPrice: maxPrice,
    setMaxPrice: setMaxPrice
  }))), /*#__PURE__*/_react["default"].createElement(_core.Divider, null), (groups || []).map(function (group, i) {
    return /*#__PURE__*/_react["default"].createElement(FeatureGroup, {
      group: group,
      key: i,
      features: features,
      setFeatures: setFeatures
    });
  }));
}
Filter.propTypes = {
  groups: _propTypes["default"].arrayOf(_propTypes["default"].object),
  features: _propTypes["default"].arrayOf(_propTypes["default"].object),
  setFeatures: _propTypes["default"].func
};
var _default = exports["default"] = Filter;